import { render, staticRenderFns } from "./icon-point.vue?vue&type=template&id=61e0741d&scoped=true"
import script from "./icon-point.vue?vue&type=script&lang=js"
export * from "./icon-point.vue?vue&type=script&lang=js"
import style0 from "./icon-point.vue?vue&type=style&index=0&id=61e0741d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e0741d",
  null
  
)

export default component.exports